<div class="subcategory_brand pointer" [style.background-image]="'url('+data.image+')'">
    <div class="white-box">
        <img [src]="data.icon" class="w-100">
    </div>
</div>